import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { Table } from "../s25-table/Table";
import { GenericTableButtonComponent } from "../s25-table/generics/generic.table.button.component";
import { Bind } from "../../decorators/bind.decorator";
import { CalendarListItem, CalendarService } from "./calendaring.service";
import { S25Util } from "../../util/s25-util";
import { S25TableComponent } from "../s25-table/s25.table.component";

@TypeManagerDecorator("s25-ng-calendaring-admin")
@Component({
    selector: "s25-ng-calendaring-admin",
    template: `
        @if (init) {
            <h2>Publisher Migration Management</h2>
            <s25-ng-table
                [dataSource]="dataSource"
                [hasFilter]="true"
                [hasRefresh]="true"
                [columnSortable]="true"
                [showHeaderWhenNoData]="true"
            >
            </s25-ng-table>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CalendaringAdminComponent implements OnInit {
    @ViewChild(S25TableComponent) table: S25TableComponent;

    init = false;
    dataSource: Table.DataSource = {
        type: "unpaginated",
        dataSource: async () => {
            let calendars = await CalendarService.getCalendars();
            return {
                rows: calendars.map((c) => {
                    return {
                        id: c.calendarId,
                        name: c.webName,
                        data: c,
                        cells: {
                            calendarId: { text: c.calendarId },
                            webName: { text: c.webName },
                            isMigrated: { text: c.isMigrated ? "Yes" : "No" },
                        },
                    };
                }),
            };
        },
        columns: [
            { id: "calendarId", header: "Calendar ID" },
            { id: "webName", header: "Web Name" },
            { id: "isMigrated", header: "Migrated" },
            GenericTableButtonComponent.Column("Migrate", this.onMigrate),
            GenericTableButtonComponent.Column("Revert", this.onRevert),
        ],
    };

    constructor(private cd: ChangeDetectorRef) {}

    @Bind
    async onMigrate(row: Table.Row, button: GenericTableButtonComponent) {
        let calendarListItem = row.data as CalendarListItem;
        if (calendarListItem.isMigrated) {
            return;
        }
        const [_, error] = await S25Util.Maybe(CalendarService.migrateCalendar(calendarListItem.calendarId));
        if (error) {
            S25Util.showError(error);
        }
        await this.table.refresh(true, true);
        return;
    }

    @Bind
    async onRevert(row: Table.Row, button: GenericTableButtonComponent) {
        let calendarListItem = row.data as CalendarListItem;
        const [_, error] = await S25Util.Maybe(CalendarService.setCalendarStatus(calendarListItem.calendarId, false));
        if (error) {
            S25Util.showError(error);
        }
        await this.table.refresh(true, true);
        return;
    }

    async ngOnInit() {
        this.init = true;
        this.cd.detectChanges();
    }
}
